import styled from 'styled-components';
export const ReceiptContainer = styled.div`
  /* --- Main Container Styles --- */
  font-family: 'Arial', sans-serif;
 width: 210mm;
  margin:0 auto 20px auto;
  padding: 40px;
  border: 1px solid #000;
  background-color: #fff;
  color: #000;
  box-sizing: border-box;
&.print{
  border: none;
}
  /* --- Nested CSS Rules --- */
  
  /* Header Section */
  .header {
    text-align: center;
    margin-bottom: 20px;
    border-bottom: 2px solid #000;
    padding-bottom: 10px;
    .headerTop{
      display: flex;
      justify-content: space-between;
      .left{
       max-width: 120px;
        img{
   width: 100%;
        }
        h2{
          font-size: 10px;
    font-family: sans-serif;
    color: #000000;
    line-height: 15px;
    font-weight: 400;
    text-align: left;
        }
      }
      .right{
        img{
          width: 130px;
        }
        p{
         font-size: 10px;
    font-family: sans-serif;
    color: #000000;
    line-height: 15px;
        }
      }
      .middle{
        .header h1 {
    font-size: 22px;
    font-weight: bold;
    margin: 5px 0;
    text-transform: uppercase;
    text-align: center;
  }

  .header h2 {
    font-size: 16px;
    margin: 5px 0;
    font-weight: normal;
    margin-top: 10px;
  }

      }
    }
  }

  
  .header .receipt-title {
    font-size: 18px;
    font-weight: bold;
    margin-top: 15px;
  }

  /* Top Info Section */
  .top-info {
    font-size: 12px;
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
  }

  .received-line {
    font-size: 14px;
    margin-bottom: 15px;
    font-weight: bold;
  }

  /* Table Section */
  table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
    font-size: 12px;
  }

  th, td {
    border: 1px solid #000;
    padding: 8px;
    text-align: left;
    vertical-align: top;
  }

  th {
    background-color: #f0f0f0;
    font-weight: bold;
  }

  .text-right {
    text-align: right;
  }

  .bold {
    font-weight: bold;
  }

  /* Words Section */
  .amount-words {
    font-size: 13px;
    margin: 15px 0;
    font-weight: bold;
    border-top: 1px dashed #000;
    border-bottom: 1px dashed #000;
    padding: 10px 0;
  }

  /* Footer Section */
  .footer {
    /* margin-top: 30px; */
    font-size: 10px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding-top: 40px;
    padding-bottom: 40px;
  }

  .qr-placeholder {
    width: 80px;
    height: 80px;
    border: 1px solid #000;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #eee;
  }

  .disclaimer {
    margin-top: 10px;
    font-size: 9px;
    text-align: center;
    color: #555;
  }
`;

 export const HeaderWrapper  = styled.div`

 top: 0;
    margin: 20px auto;
    background: #fff;
    position: sticky;
    padding: 10px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    button{
      border-radius: 6px;
      cursor: pointer;
    }
    svg{
      width: 24px;
      cursor: pointer;
    }
 `;